export default __webpack_public_path__ + "static/media/p1-img.57381b92.png";